export default function validation(response, messages, ots) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('COMPANY_SHOULD_CONTAINS_TECHNIC_WORK_ORDER_PRODUCT') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.messages.error.technicWorkOrdreProduct',
      });
    }
    if (message.indexOf('AT_LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.messages.error.leastOneProduct',
      });
    }
    if (message.indexOf('EXACTLY_ONE_PATRIMOINE_TYPE') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.messages.error.onePatrimoineType',
      });
    }
    if (message.indexOf('COMPLETION_DATE_REQUIRED_TO_COMPLETE_TECHNIC_WORKING_ORDER') === 0) {
      if (!ots || !ots.length) {
        messages.push({
          message: 'detailOrdreTravailTech.messages.error.otNeedDateRealisation',
        });
      } else {
        const elements = message.split('|')[0].split('@');
        const ids = elements[1].replace('[', '').replace(']', '').split(',');
        const codes = [];
        ids.forEach((id) => {
          const otFind = ots.find((ot) => { return ot.id === id; });
          if (otFind) codes.push(otFind.code);
        });
        if (codes.length > 0) {
          messages.push({
            message: ('listeOrdreTravailTech.messages.error' + (codes.length > 1 ? '.otNeedDateRealisationMulti' : '.otNeedDateRealisation')),
            parametres: {
              code: codes.join(', '),
            },
          });
        } else {
          messages.push({
            message: 'detailOrdreTravailTech.messages.error.otNeedDateRealisation',
          });
        }
      }
    }
    if (message.indexOf('PLANNING_DATE_REQUIRED_TO_PLAN_TECHNIC_WORKING_ORDER') === 0) {
      if (!ots || !ots.length) {
        messages.push({
          message: 'detailOrdreTravailTech.messages.error.otNeedDatePlanif',
        });
      } else {
        const elements = message.split('|')[0].split('@');
        const ids = elements[1].replace('[', '').replace(']', '').split(',');
        const codes = [];
        ids.forEach((id) => {
          const otFind = ots.find((ot) => { return ot.id === id; });
          if (otFind) codes.push(otFind.code);
        });
        if (codes.length > 0) {
          messages.push({
            message: ('listeOrdreTravailTech.messages.error' + (codes.length > 1 ? '.otNeedDatePlanifMulti' : '.otNeedDatePlanif')),
            parametres: {
              code: codes.join(', '),
            },
          });
        } else {
          messages.push({
            message: 'detailOrdreTravailTech.messages.error.otNeedDatePlanif',
          });
        }
      }
    }
    if (message.indexOf('PATRIMOINE_CAN_NOT_MODIFY') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.patrimoine.canNotChangePatrionine',
      });
    }
    if (message.indexOf('OTTECHNIQUESTOCK_CLIENT_IS_NOT_OWNER') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.patrimoine.clientNotOwner',
      });
    }
    if (message.indexOf('OTTECHNIQUESTOCK_OT_HAS_NO_DISPOSITIF_IMPRESSION') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.patrimoine.hasToBeDispositif',
      });
    }
    if (message.indexOf('ETAT_A_EXPEDIER_NOT_ALLOWED') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.patrimoine.etatAExpedierNotAllowed',
      });
    }
    if (message.indexOf('MODULE_IMPRESSION_NOT_ACTIVATED') === 0) {
      messages.push({
        message: 'addEditOrdreTravailTech.patrimoine.moduleImpressionNotActivated',
      });
    }
    if (message.indexOf('PATRIMOINE_ETAT_HISTORIQUE_CANNOT_BE_A_SAME') === 0) {
      messages.push({
        message: 'patrimoine.error.etatCannotBeASame',
      });
    }
    if (message.indexOf('OT_USER_IS_NOT_A_TECHNICIAN') === 0) {
      messages.push({
        message: 'detailOrdreTravailTech.messages.error.userIsNotTechnician',
      });
    }
  });
}
